<template>
    <div class="main">
        <MyHeader index="1"></MyHeader>
        <div class="title">
            <div class="container">
                <h2>关于我们</h2>
                <h3>About us</h3>
            </div>
        </div>
        <div class="aboutUsInfo">
            <div class="container">
                <div class="content">
                    <div class="leftMenu">
                        <ul>
                            <li>
                                <router-link to="/aboutUs">
                                    <i>{{$t('ccapp.tit')}}</i>
                                    <b></b>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/frame">
                                    <i>{{$t('ccapp.tit1')}}</i>
                                    <b></b>
                                </router-link>
                            </li>
                            <li class="on">
                                <router-link to="/job">
                                    <i>{{$t('ccapp.tit5')}}</i>
                                    <b></b>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="rightContent">
                        <div v-for="item in fullList">
                            <div class="jobInfo" v-if="id === item.id && zh == 'zh_CN'">
                            <h3>{{item.title}}</h3>
                            <h5>{{item.created_at}}</h5>
                            <h6>工作地点：{{item.address}}</h6>
                            <h4>岗位职责</h4>
                            <div class="jobInfoText">
                                <div class="desc newsInfo ql-editor" v-html="item.duty"></div>
                            </div>
                            
                            <h4>任职资格</h4>
                            <div class="jobInfoText">
                                
                                <div class="desc newsInfo ql-editor"  v-html="item.condition"></div>
                                
                            </div>
                            <h4>薪资待遇</h4>
                            <div class="jobInfoText">
                                <div class="desc newsInfo ql-editor" v-html="item.welfare"></div>
                            </div>
                            <h4>申请方式</h4>
                            <div class="jobInfoText">
                                <div class="desc newsInfo ql-editor" v-html="item.apply"></div>
                            </div>
                        </div>
                        <div class="jobInfo" v-if="id === item.id && zh == 'en_US'">
                            <h3>{{item.title_en}}</h3>
                            <h5>{{item.created_at}}</h5>
                            <h6>Location：{{item.address_en}}</h6>
                            <h4>Key Responsibilities</h4>
                            <div class="jobInfoText">
                                <div class="desc newsInfo ql-editor" v-html="item.duty_en"></div>
                            </div>
                            <h4>Qualifications</h4>
                            <div class="jobInfoText">
                                <div class="desc newsInfo ql-editor" v-html="item.condition_en"></div>
                            </div>
                            <h4>Salary and Benefits</h4>
                            <div class="jobInfoText">
                                <div class="desc newsInfo ql-editor" v-html="item.welfare_en"></div>
                            </div>
                            <h4>How to Apply</h4>
                            <div class="jobInfoText">
                                <div class="desc newsInfo ql-editor" v-html="item.apply_en"></div>
                            </div>
                        </div>
                        </div>
                        <!--<div class="jobInfo" v-if="id === 1 && this.$i18n.locale == 'zh_CN'">
                            <h3>项目经理</h3>
                            <h5>2020-08-20</h5>
                            <h6>工作地点：北京</h6>
                            <h4>岗位职责</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1. 开展国内外清洁空气政策、方法和技术等相关中英文研究报告和评估报告的编制工作，组织完成中国清洁空气年度报告；</p>
                                </li>
                                <li>
                                    <p>2. 为政府部门空气质量改善行动提供技术支持和建议； </p>
                                </li>
                                <li>
                                    <p>3. 与国内和国际研究机构共同开展清洁空气技术和政策相关研究；</p>
                                </li>
                            </ul>
                            <h4>任职资格</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1. 环境类或相关专业硕士及以上学历（优秀本科生亦可）， 有NGO相关工作经历者优先；</p>
                                </li>
                                <li>
                                    <p>2. 具备大气污染防治领域相关研究经验；</p>
                                </li>
                                <li>
                                    <p>3. 良好的中英文写作能力，较好的英语口语表达能力；</p>
                                </li>
                                <li>
                                    <p>4. 责任心强，工作认真细心，有能力同时完成多个项目的工作；</p>
                                </li>
                                <li>
                                    <p>5. 具有良好的沟通能力和学习能力，以及较强的团队协作能力。</p>
                                </li>
                            </ul>
                            <h4>薪资待遇</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>根据申请人情况提供具有竞争力的薪酬，具体面议；提供五险一金、带薪休假、进修培训等福利。</p>
                                </li>
                            </ul>
                            <h4>申请方式</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>有意者请将个人简历发至：makeinsight@makeins.cn；标题格式为：姓名+职位+最快到岗时间。</p>
                                </li>
                            </ul>
                        </div>
                        <div class="jobInfo" v-if="id === 1 && this.$i18n.locale == 'en_US'">
                            <h3>Project Manager</h3>
                            <h5>2020-08-20</h5>
                            <h6>Location：Beijing</h6>
                            <h4>Key Responsibilities</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1. Writing both English and Chinese research reports and assessment reports regarding clean air policies, methods and technologies；</p>
                                </li>
                                <li>
                                    <p>2. Providing technical support and suggestions for government’s actions for air quality improvement； </p>
                                </li>
                                <li>
                                    <p>3. Carrying out research on technologies and policies about cleaning air in cooperation with domestic and oversea institutes；</p>
                                </li>
                            </ul>
                            <h4>Qualifications</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1. Master’s degree or above, in the field of environmental science or relevant disciplines (excellent Bachelors’ degree holders can also be considered). Experience in NGO is preferred；</p>
                                </li>
                                <li>
                                    <p>2. Experience in studying prevention of atmospheric pollution or relevant field；</p>
                                </li>
                                <li>
                                    <p>3. Fluency in both oral and written English and Chinese；</p>
                                </li>
                                <li>
                                    <p>4. Responsibility and carefulness in work, ability in dealing with multiple tasks simultaneously；</p>
                                </li>
                                <li>
                                    <p>5. Good communication and learning skills, team player。</p>
                                </li>
                            </ul>
                            <h4>Salary and Benefits</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>A competitive salary is offered based on the qualifications of the applicant. Five insurances and housing fund, paid vacation, training and other benefits are also offered.</p>
                                </li>
                            </ul>
                            <h4>How to Apply</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>Send CV to makeinsight@makeins.cn</p>
									<p>Please write the email subject line as: Name/Position/the earliest time of arrival.</p>
                                </li>
                            </ul>
                        </div>
                        
                        <div class="jobInfo" v-if="id === 2 && this.$i18n.locale == 'zh_CN'">
                            <h3>媒体经理</h3>
                            <h5>2019-05-06</h5>
                            <h6>工作地点：北京</h6>
                            <h4>岗位职责</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1  策划与实施清洁空气伙伴项目相关的会议和交流活动；</p>
                                </li>
                                <li>
                                    <p>2  通过微信或其他平面媒体宣传和推广大气污染治理经验；</p>
                                </li>
                                <li>
                                    <p>3  拓展及维护国内和国际研究机构、相关管理职能部门等 业内人士的公共关系。</p>
                                </li>
                            </ul>
                            <h4>任职资格</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1 新闻传播类、环境类或相关专业硕士及以上学历（优秀 本科生亦可）；</p>
                                </li>
                                <li>
                                    <p>2 较好的英语口语表达能力，良好的中英文写作能力；</p>
                                </li>
                                <li>
                                    <p>3 具有相关工作经验，具备大气污染防治知识背景，对环 境问题，特别是空气污染的知识有浓厚兴趣；</p>
                                </li>
                                <li>
                                    <p>4 责任心强，工作认真，具有良好的沟通能力和学习能力，以及较强的团队协作能力。</p>
                                </li>

                            </ul>
                            <h4>薪资待遇</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>根据申请人情况提供具有竞争力的薪酬，具体面议；提供五险一金、带薪休假、进修培训等福利。</p>
                                </li>
                            </ul>
                            <h4>申请方式</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>有意者请将个人简历发至：makeinsight@makeins.cn；标题格式为：姓名+职位+最快到岗时间。</p>
                                </li>
                            </ul>
                        </div>
                        <div class="jobInfo" v-if="id === 2 && this.$i18n.locale == 'en_US'">
                            <h3>Media Manager</h3>
                            <h5>2020-08-20</h5>
                            <h6>Location：Beijing</h6>
                            <h4>Key Responsibilities</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1  Writing both English and Chinese research reports and assessment reports regarding clean air policies, methods and technologies；</p>
                                </li>
                                <li>
                                    <p>2  Providing technical support and suggestions for government’s actions for air quality improvement；</p>
                                </li>
                                <li>
                                    <p>3  Carrying out research on technologies and policies about cleaning air in cooperation with domestic and oversea institutes；</p>
                                </li>
                            </ul>
                            <h4>Qualifications</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1 Master’s degree or above, in the field of environmental science or relevant disciplines (excellent Bachelors’ degree holders can also be considered). Experience in NGO is preferred；</p>
                                </li>
                                <li>
                                    <p>2 Experience in studying prevention of atmospheric pollution or relevant field；</p>
                                </li>
                                <li>
                                    <p>3 Fluency in both oral and written English and Chinese；</p>
                                </li>
                                <li>
                                    <p>4 Responsibility and carefulness in work, ability in dealing with multiple tasks simultaneously；</p>
                                </li>
                                <li>
                                    <p>5 Good communication and learning skills, team player；</p>
                                </li>

                            </ul>
                            <h4>Salary and Benefits</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>A competitive salary is offered based on the qualifications of the applicant. Five insurances and housing fund, paid vacation, training and other benefits are also offered.</p>
                                </li>
                            </ul>
                            <h4>How to Apply</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>Send CV to makeinsight@makeins.cn</p>
									<p>Please write the email subject line as: Name/Position/the earliest time of arrival.</p>
                                </li>
                            </ul>
                        </div>
                        
                        
                        <div class="jobInfo" v-if="id === 4 && this.$i18n.locale == 'zh_CN'">
                            <h3>传播官员</h3>
                            <p>CCAPP 秘书处现招聘1名传播官员，参与信息传播、管理与交流等工作。</p>
                            <h5>2020-12-22</h5>
                            <h6>工作地点：北京</h6>
                           
                            <h4>岗位职责</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1  协助策划与实施清洁空气伙伴项目相关的会议和交流活动；</p>
                                </li>
                                <li>
                                    <p>2  协助通过微信或其他平面媒体宣传和推广大气污染治理经验及协同应对气候变化相关内容；</p>
                                </li>
                                <li>
                                    <p>3  协助拓展及维护国内和国际研究机构、相关管理职能部门等业内人士的公共关系。</p>
                                </li>
                            </ul>
                            <h4>任职资格</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1 新闻传播类、环境类或相关专业硕士及以上学历（优秀本科生亦可），具有相关工作经验，具有NGO工作经验者优先；</p>
                                </li>
                                <li>
                                    <p>2 较好的中英文沟通能力，良好的中英文写作能力；</p>
                                </li>
                                <li>
                                    <p>3 较强的宣传推广、组织策划与协调能力；</p>
                                </li>
                                <li>
                                    <p>4 具备大气污染防治、气候变化应对相关知识背景，对环境问题，特别是空气污染的知识有浓厚兴趣；</p>
                                </li>
                                 <li>
                                    <p>5 责任心强，工作认真，具有良好的学习能力和创新精神，以及较强的团队协作能力。</p>
                                </li>

                            </ul>
                            <h4>薪资待遇</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>根据申请人情况提供具有竞争力的薪酬，具体面议；提供五险一金、带薪休假、进修培训等福利。</p>
                                </li>
                            </ul>
                            <h4>申请方式</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>有意者请将个人简历发至：makeinsight@makeins.cn；标题格式为：姓名+职位+最快到岗时间。</p>
                                </li>
                            </ul>
                        </div>
                        <div class="jobInfo" v-if="id === 4 && this.$i18n.locale == 'en_US'">
                            <h3>Communication Assistant</h3>
                            <p>The CCAPP Secretariat is now hiring one Communication Assistant to participate in information dissemination, as well as management and communication activities. </p>
                            <h5>2020-12-22</h5>
                            <h6>Location：Beijing</h6>
                            <h4>Key Responsibilities</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1  Planning and implementing meetings and communication activities related to clean air partnership programs.</p>
                                </li>
                                <li>
                                    <p>2  Promoting and sharing experience regarding air pollution prevention and control via WeChat or other social media.</p>
                                </li>
                                <li>
                                    <p>3  Expanding and maintaining the relationships with domestic and international research institutes, industry professionals and other authorities.</p>
                                </li>
                            </ul>
                            <h4>Qualifications</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1 Master’s degree or above, in journalism, environmental science or relevant disciplines (excellent Bachelors’ degree holders maybe be considered), NGO related working experiences are assets </p>
                                </li>
                                <li>
                                    <p>2 Research experience in air pollution prevention and control, climate change mitigation, or related field;</p>
                                </li>
                                <li>
                                    <p>3 Fluent in spoken and written English and Chinese;</p>
                                </li>
                                <li>
                                    <p>4 Familiar with campaign and content promoting; strong ability of planning and coordination;</p>
                                </li>
                                <li>
                                    <p>5 Strong sense of responsibility, detail-oriented, and able to conduct multiple tasks simultaneously;</p>
                                </li>
                                <li>
                                    <p>6 Good communication and learning skills, and a good team player.</p>
                                </li>

                            </ul>
                            <h4>Salary and Benefits</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>A competitive salary is offered based on the qualifications of the applicant. Five insurances and housing fund, paid vacation, training and other benefits are also offered.</p>
                                </li>
                            </ul>
                            <h4>How to Apply</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>Send CV to makeinsight@makeins.cn</p>
									<p>Please write the email subject line as: Name/Position/the earliest time of arrival.</p>
                                </li>
                            </ul>
                        </div>
                        
                    
                    	<div class="jobInfo" v-if="id === 5 && this.$i18n.locale == 'zh_CN'">
                            <h3>项目官员</h3>
                            <p>CCAPP 秘书处现招聘1名项目官员，参与相关研究、管理与交流等工作。</p>
                             <h5>2020-12-22</h5>
                            <h6>工作地点：北京</h6>
                            <h4>岗位职责</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1  协助开展国内外清洁空气政策、方法和技术等相关中英文研究报告和评估报告的编制工作，协助完成中国清洁空气年度报告；</p>
                                </li>
                                <li>
                                    <p>2  协助为政府部门空气质量改善行动提供技术支持和建议；</p>
                                </li>
                                <li>
                                    <p>3  协助与国内和国际研究机构共同开展清洁空气技术和政策相关研究。</p>
                                </li>
                            </ul>
                            <h4>任职资格</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1 环境类或相关专业硕士及以上学历（优秀本科生亦可），有NGO 相关工作经历者优先；</p>
                                </li>
                                <li>
                                    <p>2 具备大气污染防治、气候变化应对领域相关研究经验；</p>
                                </li>
                                <li>
                                    <p>3 良好的中英文写作能力，较好的英语口语表达能力；</p>
                                </li>
                                <li>
                                    <p>4 责任心强，工作认真细心，有能力同时完成多个项目的工作；</p>
                                </li>
                                 <li>
                                    <p>5 具有良好的沟通能力和学习能力，以及较强的团队协作能力。</p>
                                </li>

                            </ul>
                            <h4>薪资待遇</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>根据申请人情况提供具有竞争力的薪酬，具体面议；提供五险一金、带薪休假、进修培训等福利。</p>
                                </li>
                            </ul>
                            <h4>申请方式</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>有意者请将个人简历发至：makeinsight@makeins.cn；标题格式为：姓名+职位+最快到岗时间。</p>
                                </li>
                            </ul>
                        </div>
                        <div class="jobInfo" v-if="id === 5 && this.$i18n.locale == 'en_US'">
                            <h3>Project Assistant</h3>
                            <p>The CCAPP Secretariat is now hiring one Project Assistant to participate in research projects, as well as management and communication activities. </p>
                             <h5>2020-12-22</h5>
                            <h6>Location：Beijing</h6>
                            <h4>Key Responsibilities</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1  Assisting in writing both English and Chinese research and assessment reports regarding clean air policies, methods and technologies;</p>
                                </li>
                                <li>
                                    <p>2  Providing technical support and suggestions for government air quality improvement initiatives;</p>
                                </li>
                                <li>
                                    <p>3  Conducting research on clean air technologies and policies by collaborating with national and international research institutes .</p>
                                </li>
                            </ul>
                            <h4>Qualifications</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1 Master’s degree or above, in environmental science or relevant disciplines (excellent Bachelors’ degree holders may also be considered). Working experience in NGO is preferred;</p>
                                </li>
                                <li>
                                    <p>2 Research experience in air pollution prevention and control, climate change mitigation, or related field;</p>
                                </li>
                                <li>
                                    <p>3 Fluent in spoken and written English and Chinese;</p>
                                </li>
                                
                                <li>
                                    <p>4 Strong sense of responsibility, paying attention to detail, and able to conduct multiple tasks simultaneously;</p>
                                </li>
                                <li>
                                    <p>5 Good communication and learning skills, and a good team player.</p>
                                </li>

                            </ul>
                            <h4>Salary and Benefits</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>A competitive salary is offered based on the qualifications of the applicant. Five insurances and housing fund, paid vacation, training and other benefits are also offered.</p>
                                </li>
                            </ul>
                            <h4>How to Apply</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>Send CV to makeinsight@makeins.cn</p>
									<p>Please write the email subject line as: Name/Position/the earliest time of arrival.</p>
                                </li>
                            </ul>
                        </div>
                        
                        
                        <div class="jobInfo" v-if="id === 3">
                            <h3>实习生</h3>
                            <h5>2019-05-06</h5>
                            <h6>工作地点：北京</h6>
                            <h4>岗位职责</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1. 跟踪清洁空气领域相关数据：整理清洁空气领域政策、协助收集数据资料、数据整理分析；</p>
                                </li>
                                <li>
                                    <p>2. 协助举办线下会议与活动：活动资料准备、活动配套传播工作。 </p>
                                </li>
                                <li>
                                    <p>3. 信息传播：网站、微信公众号筹建维护。</p>
                                </li>
                            </ul>
                            <h4>任职资格</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1. 全日制在读研究生或本科生。</p>
                                </li>
                                <li>
                                    <p>2. 能连续工作6个月左右。每周一到周五之间至少可以有3天来办公室工作</p>
                                </li>
                                <li>
                                    <p>3. 对清洁空气及低碳规划领域的工作有浓厚兴趣；优秀的逻辑思维和分析能力；优秀的中英文表达沟通能力；</p>
                                </li>
                                <li>
                                    <p>4. 强烈的工作责任感；强烈的求知欲和出色的学习能力。</p>
                                </li>
                                <li>
                                    <p>5. 具备大气污染防治领域相关经验者优先</p>
                                </li>
                                <li>
                                    <p>6. 具有新闻稿撰写、微信公众号运营经验者优先。</p>
                                </li>
                            </ul>
                            <h4>申请方式</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>有意者请将个人简历发至：makeinsight@makeins.cn；</p>
                                </li>
                                <li>
                                    <p>邮件标题格式为：姓名-性别-学校-专业-预计毕业时间-连续实习*个月-每周能工作*个工作日（周一至周五之间）</p>
                                </li>
                            </ul>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <MyFooter></MyFooter>
    </div>
</template>

<script>
    import MyHeader from './common/MyHeader';
    import MyFooter from './common/MyFooter';
    import filter from '../filter.js';
    import {createJobs, getJobsList, getJobsDetails, deleteJobs, putJobs} from '@/services/jobs';
    export default {
        name: "WorkExperiencePage",
        components: { MyHeader,MyFooter },
        data(){
            return{
                id:Number(this.$route.params.id),
                zh: this.$i18n.locale,
                full:{
                    page_size:100,
                    page:1,
                    search_str:'',
                    category_id:72,
                    language:'',
                    // type: 1
                },
                
                fullList:[],

                pageInfo:{
                    total:0,        // 记录总条数   默认空，如果小于pageNum则组件不显示   类型Number
                    current:1,      // 当前页数，   默认为1                             类型Number
                    pagenum:6,      // 每页显示条数,默认10                              类型Number
                    pagegroup:3,    // 分页条数     默认为5，需传入奇数                  类型Number
                    skin:'#13AE67'  // 选中页码的颜色主题 默认为'#16a086'                类型String
                },
            }
        },
        
        mounted(){
            this.getList(this.full);
        },
        methods:{
            getList(params){
                
                getJobsList(params).then(res => {
                    let list = res.items;
                    for (var i in list) {
                        let item = list[i];
                        item.created_at = filter.dateFormat(item.created_at,'yyyy-mm-dd');
                        item.updated_at = filter.dateFormat(item.updated_at,'yyyy-mm-dd');
                    }
                    
                    // this.pageInfo.total= res._meta.totalCount;
                    // this.pageInfo.current= res._meta.currentPage;
                    // this.pageInfo.pagenum= res._meta.perPage;
                    this.fullList = list
                    // if(params.type == 0){
                    //     this.fullList = list
                    // }
                    // if(params.type == 1){
                    //     this.practiceList = list
                    // }
                    
                }).catch();
            },
            pagechange(current){
                this.page.page = current;
                this.getList();
            },
            search(){
                this.getList();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .desc {
        padding: 0 16px;
        border-radius: 18px;
        height: 36px;
        overflow: hidden;
        line-height: 36px;
        margin-bottom: 10px;
        color: #252525;
        font-size: 15px;
        
    }
    .main{
        .title{
            height:380px;
            background: url("./image/aboutUsImg.jpg") no-repeat center center;
            background-size: cover;
            .container{
                h2{
                    padding-top: 180px;
                    text-align: center;
                    color: #304656;
                    height:42px;
                    font-size:32px;
                    font-weight:bold;
                    line-height:42px;
                }
                h3{
                    text-align: center;
                    height:29px;
                    font-size:22px;
                    line-height:29px;
                    color: #304656;
                }
            }
        }
        .aboutUsInfo{
            .container{
                border-top: 1px solid #E6E6E6;
                .content{
                    margin-top: 66px;
                    overflow: hidden;
                    margin-bottom: 48px;
                    .leftMenu{
                        width: 246px;
                        float: left;
                        ul{
                            li{
                                padding: 0 16px;
                                border-radius: 18px;
                                height: 36px;
                                overflow: hidden;
                                line-height: 36px;
                                margin-bottom: 10px;
                                &:last-child{
                                    margin-bottom: 0;
                                }
                                a{
                                    display: block;
                                    height: 100%;
                                }
                                i{
                                    display: inline-block;
                                    float: left;
                                    color: #252525;
                                    font-size: 16px;
                                }
                                b{
                                    display: inline-block;
                                    float: right;
                                    width: 30px;
                                    height: 100%;
                                    background: url("./image/yy2.png") no-repeat center center;
                                    background-size: 100%;
                                    line-height: 36px;
                                }

                            }
                            .on{
                                background: #13AE67;
                                i{
                                    color: #FFFFFF;
                                }
                                b{
                                    background: url("./image/yy.png") no-repeat center center;
                                    background-size: 86%;
                                }
                            }
                        }
                    }
                    .rightContent{
                        float: right;
                        margin-left: 88px;
                        width: 866px;
                        .jobInfo{
                            h3{
                                height:26px;
                                font-size:20px;
                                font-weight:bold;
                                color:rgba(37,37,37,1);
                                line-height:26px;
                            }
                            h5{
                                margin-top: 12px;
                                height:12px;
                                font-size:12px;
                                color:rgba(102,102,102,1);
                                line-height:16px;
                            }
                            h6{
                                margin-top: 12px;
                                height:16px;
                                font-size:14px;
                                color:rgba(102,102,102,1);
                                line-height:16px;
                            }
                            h4{
                                height:21px;
                                font-size:16px;
                                font-weight:bold;
                                color:rgba(37,37,37,1);
                                line-height:21px;
                                margin-top: 33px;
                            }
                            .jobInfoText{
                                margin-top: 16px;
                                li{
                                    line-height:34px;
                                    font-size:14px;
                                    p{
                                        color: #252525;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    /*!
 * Quill Editor v1.3.6
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
.ql-container {
  box-sizing: border-box;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
  height: 100%;
  margin: 0px;
  position: relative;
}
.ql-container.ql-disabled .ql-tooltip {
  visibility: hidden;
}
.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {
  pointer-events: none;
}
.ql-clipboard {
  left: -100000px;
  height: 1px;
  overflow-y: hidden;
  position: absolute;
  top: 50%;
}
.ql-clipboard p {
  margin: 0;
  padding: 0;
}
.ql-editor {
  box-sizing: border-box;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  padding: 12px 15px;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.ql-editor > * {
  cursor: text;
}
.ql-editor p,
.ql-editor ol,
.ql-editor ul,
.ql-editor pre,
.ql-editor blockquote,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6 {
  margin: 0;
  padding: 0;
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol,
.ql-editor ul {
  padding-left: 1.5em;
}
.ql-editor ol > li,
.ql-editor ul > li {
  list-style-type: none;
}
.ql-editor ul > li::before {
  content: "\2022";
}
.ql-editor ul[data-checked="true"],
.ql-editor ul[data-checked="false"] {
  pointer-events: none;
}
.ql-editor ul[data-checked="true"] > li *,
.ql-editor ul[data-checked="false"] > li * {
  pointer-events: all;
}
.ql-editor ul[data-checked="true"] > li::before,
.ql-editor ul[data-checked="false"] > li::before {
  color: #777;
  cursor: pointer;
  pointer-events: all;
}
.ql-editor ul[data-checked="true"] > li::before {
  content: "\2611";
}
.ql-editor ul[data-checked="false"] > li::before {
  content: "\2610";
}
.ql-editor li::before {
  display: inline-block;
  white-space: nowrap;
  width: 1.2em;
}
.ql-editor li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}
.ql-editor li.ql-direction-rtl::before {
  margin-left: 0.3em;
  margin-right: -1.5em;
}
.ql-editor ol li:not(.ql-direction-rtl),
.ql-editor ul li:not(.ql-direction-rtl) {
  padding-left: 1.5em;
}
.ql-editor ol li.ql-direction-rtl,
.ql-editor ul li.ql-direction-rtl {
  padding-right: 1.5em;
}
.ql-editor ol li {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-0;
}
.ql-editor ol li:before {
  content: counter(list-0, decimal) ". ";
}
.ql-editor ol li.ql-indent-1 {
  counter-increment: list-1;
}
.ql-editor ol li.ql-indent-1:before {
  content: counter(list-1, lower-alpha) ". ";
}
.ql-editor ol li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-2 {
  counter-increment: list-2;
}
.ql-editor ol li.ql-indent-2:before {
  content: counter(list-2, lower-roman) ". ";
}
.ql-editor ol li.ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-3 {
  counter-increment: list-3;
}
.ql-editor ol li.ql-indent-3:before {
  content: counter(list-3, decimal) ". ";
}
.ql-editor ol li.ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-4 {
  counter-increment: list-4;
}
.ql-editor ol li.ql-indent-4:before {
  content: counter(list-4, lower-alpha) ". ";
}
.ql-editor ol li.ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-5 {
  counter-increment: list-5;
}
.ql-editor ol li.ql-indent-5:before {
  content: counter(list-5, lower-roman) ". ";
}
.ql-editor ol li.ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-6 {
  counter-increment: list-6;
}
.ql-editor ol li.ql-indent-6:before {
  content: counter(list-6, decimal) ". ";
}
.ql-editor ol li.ql-indent-6 {
  counter-reset: list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-7 {
  counter-increment: list-7;
}
.ql-editor ol li.ql-indent-7:before {
  content: counter(list-7, lower-alpha) ". ";
}
.ql-editor ol li.ql-indent-7 {
  counter-reset: list-8 list-9;
}
.ql-editor ol li.ql-indent-8 {
  counter-increment: list-8;
}
.ql-editor ol li.ql-indent-8:before {
  content: counter(list-8, lower-roman) ". ";
}
.ql-editor ol li.ql-indent-8 {
  counter-reset: list-9;
}
.ql-editor ol li.ql-indent-9 {
  counter-increment: list-9;
}
.ql-editor ol li.ql-indent-9:before {
  content: counter(list-9, decimal) ". ";
}
.ql-editor .ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 1em;
}
.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 4.5em;
}
.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 3em;
}
.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 4.5em;
}
.ql-editor .ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em;
}
.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 7.5em;
}
.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 6em;
}
.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 7.5em;
}
.ql-editor .ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em;
}
.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 10.5em;
}
.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 9em;
}
.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 10.5em;
}
.ql-editor .ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em;
}
.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 13.5em;
}
.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 12em;
}
.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 13.5em;
}
.ql-editor .ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em;
}
.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 16.5em;
}
.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 15em;
}
.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 16.5em;
}
.ql-editor .ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em;
}
.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 19.5em;
}
.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 18em;
}
.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 19.5em;
}
.ql-editor .ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em;
}
.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 22.5em;
}
.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 21em;
}
.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 22.5em;
}
.ql-editor .ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em;
}
.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 25.5em;
}
.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 24em;
}
.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 25.5em;
}
.ql-editor .ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 27em;
}
.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 28.5em;
}
.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 27em;
}
.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 28.5em;
}
.ql-editor .ql-video {
  display: block;
  max-width: 100%;
}
.ql-editor .ql-video.ql-align-center {
  margin: 0 auto;
}
.ql-editor .ql-video.ql-align-right {
  margin: 0 0 0 auto;
}
.ql-editor .ql-bg-black {
  background-color: #000;
}
.ql-editor .ql-bg-red {
  background-color: #e60000;
}
.ql-editor .ql-bg-orange {
  background-color: #f90;
}
.ql-editor .ql-bg-yellow {
  background-color: #ff0;
}
.ql-editor .ql-bg-green {
  background-color: #008a00;
}
.ql-editor .ql-bg-blue {
  background-color: #06c;
}
.ql-editor .ql-bg-purple {
  background-color: #93f;
}
.ql-editor .ql-color-white {
  color: #fff;
}
.ql-editor .ql-color-red {
  color: #e60000;
}
.ql-editor .ql-color-orange {
  color: #f90;
}
.ql-editor .ql-color-yellow {
  color: #ff0;
}
.ql-editor .ql-color-green {
  color: #008a00;
}
.ql-editor .ql-color-blue {
  color: #06c;
}
.ql-editor .ql-color-purple {
  color: #93f;
}
.ql-editor .ql-font-serif {
  font-family: Georgia, Times New Roman, serif;
}
.ql-editor .ql-font-monospace {
  font-family: Monaco, Courier New, monospace;
}
.ql-editor .ql-size-small {
  font-size: 0.75em;
}
.ql-editor .ql-size-large {
  font-size: 1.5em;
}
.ql-editor .ql-size-huge {
  font-size: 2.5em;
}
.ql-editor .ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}
.ql-editor .ql-align-center {
  text-align: center;
}
.ql-editor .ql-align-justify {
  text-align: justify;
}
.ql-editor .ql-align-right {
  text-align: right;
}
.ql-editor.ql-blank::before {
  color: rgba(0, 0, 0, 0.6);
  content: attr(data-placeholder);
  font-style: italic;
  left: 15px;
  pointer-events: none;
  position: absolute;
  right: 15px;
}

.ql-picker-item[data-value="10px"]::before,
.ql-picker-label[data-value="10px"]::before {
  content: "10px" !important;
}

.ql-picker-item[data-value="12px"]::before,
.ql-picker-label[data-value="12px"]::before {
  content: "12px" !important;
}

.ql-picker-item[data-value="14px"]::before,
.ql-picker-label[data-value="14px"]::before {
  content: "14px" !important;
}

.ql-picker-item[data-value="16px"]::before,
.ql-picker-label[data-value="16px"]::before {
  content: "16px" !important;
}

.ql-picker-item[data-value="18px"]::before,
.ql-picker-label[data-value="18px"]::before {
  content: "18px" !important;
}

.ql-picker-item[data-value="20px"]::before,
.ql-picker-label[data-value="20px"]::before {
  content: "20px" !important;
}

.ql-picker-item[data-value="24px"]::before,
.ql-picker-label[data-value="24px"]::before {
  content: "24px" !important;
}

.ql-picker-item[data-value="30px"]::before,
.ql-picker-label[data-value="30px"]::before {
  content: "30px" !important;
}

.ql-picker-item[data-value="32px"]::before,
.ql-picker-label[data-value="32px"]::before {
  content: "32px" !important;
}

.ql-picker-item[data-value="36px"]::before,
.ql-picker-label[data-value="36px"]::before {
  content: "36px" !important;
}

.ql-picker.ql-lineheight {
  width: 58px;
}

.ql-picker.ql-lineheight .ql-picker-item[data-value="1"]::before {
  content: "1";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="1"]::before {
  content: "1" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="1.2"]::before {
  content: "1.2";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="1.2"]::before {
  content: "1.2" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="1.5"]::before {
  content: "1.5";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="1.5"]::before {
  content: "1.5" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="1.6"]::before {
  content: "1.6";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="1.6"]::before {
  content: "1.6" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="1.8"]::before {
  content: "1.8";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="1.8"]::before {
  content: "1.8" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="2"]::before {
  content: "2";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="2"]::before {
  content: "2" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="2.4"]::before {
  content: "2.4";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="2.4"]::before {
  content: "2.4" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="2.8"]::before {
  content: "2.8";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="2.8"]::before {
  content: "2.8" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="3"]::before {
  content: "3";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="3"]::before {
  content: "3" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="4"]::before {
  content: "4";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="4"]::before {
  content: "4" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="5"]::before {
  content: "5";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="5"]::before {
  content: "5" !important;
}
</style>
